export default __webpack_public_path__ + "daed327f431cb063c043fdc921c61b48.jpg";